// src/components/AppShell.tsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopNav from "./TopNav";

export type Role = "tenant" | "admin";

type Props = {
  children: React.ReactNode;
  onLogout: () => void;
  authRole: Role;
};

export default function AppShell({ children, onLogout, authRole }: Props) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();

  // Close drawer on route change (mobile UX)
  useEffect(() => {
    setIsDrawerOpen(false);
  }, [location.pathname]);

  return (
    <div className="appShell">
      <Sidebar
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onLogout={onLogout}
        authRole={authRole}
      />

      <div className="appMain">
        <TopNav
          isDrawerOpen={isDrawerOpen}
          onToggleDrawer={() => setIsDrawerOpen((v) => !v)}
          onCloseDrawer={() => setIsDrawerOpen(false)}
          onLogout={onLogout}
          authRole={authRole}
        />

        <main className="appContent">{children}</main>
      </div>
    </div>
  );
}
